import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../css/auth.css';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated, loading: authLoading, error: authError } = useAuth();

  const [formData, setFormData] = useState({
    username: '',  // email을 username으로 변경
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  // 로그인 상태일 때 리다이렉트
  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  // 입력값 변경 처리
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // 입력 시 해당 필드 에러 제거
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // 폼 유효성 검사
  const validateForm = () => {
    const newErrors = {};

    if (!formData.username) {
      newErrors.username = '사용자명을 입력해주세요.';
    }

    if (!formData.password) {
      newErrors.password = '비밀번호를 입력해주세요.';
    }

    return newErrors;
  };

  // 폼 제출 처리
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 유효성 검사
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    const result = await login(formData.username, formData.password);
    
    if (!result.success) {
      setErrors({ submit: result.error });
      setIsSubmitting(false);
    }
    // 성공 시 useEffect에서 자동 리다이렉트
  };

  return (
    <div className="auth-container">
      <div className="page-header">
        <h1 className="page-title">Magic AI Card</h1>
        <p className="page-subtitle">AI O2O - DB 손해보험</p>
      </div>
      <div className="auth-wrapper">
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-title">로그인</h1>
            <p className="auth-subtitle">계정에 로그인하여 서비스를 이용하세요</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            {(errors.submit || authError) && (
              <div className="error-message">
                {errors.submit || authError}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="username" className="form-label">
                사용자명
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className={`form-input ${errors.username ? 'error' : ''}`}
                placeholder="사용자명을 입력하세요"
                disabled={isSubmitting}
              />
              {errors.username && (
                <span className="field-error">{errors.username}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                비밀번호
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className={`form-input ${errors.password ? 'error' : ''}`}
                placeholder="••••••••"
                disabled={isSubmitting}
              />
              {errors.password && (
                <span className="field-error">{errors.password}</span>
              )}
            </div>

            <div className="form-options">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  disabled={isSubmitting}
                />
                <span>로그인 상태 유지</span>
              </label>
              {/* <Link to="/forgot-password" className="link-text">
                비밀번호 찾기
              </Link> */}
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmitting || authLoading}
            >
              {isSubmitting ? '로그인 중...' : '로그인'}
            </button>
          </form>

          {/* <div className="auth-footer">
            <p>
              계정이 없으신가요?{' '}
              <Link to="/signup" className="link-text">
                회원가입
              </Link>
            </p>
            <div className="test-account-info" style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f3f4f6', borderRadius: '8px' }}>
              <p style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '5px' }}>테스트 계정:</p>
              <p style={{ fontSize: '13px', color: '#6b7280' }}>사용자명: db_admin</p>
              <p style={{ fontSize: '13px', color: '#6b7280' }}>비밀번호: 1234</p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;